import { z } from 'zod';

export const FIRST_PAGE = 1;

export const paginationMetaSchema = z.object({
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  totalPages: z.number(),
});

export type PaginationMeta = z.infer<typeof paginationMetaSchema>;

export interface PageRequest {
  page: number;
  pageSize: number;
}

export function getNextPageFromMeta(lastPage: { meta: PaginationMeta }): number | undefined {
  const { page, totalPages } = lastPage.meta;
  return page < totalPages ? page + 1 : undefined;
}
